import WallexService from './WallexService'
import { SimplePaymentRetrieve } from '../domain/SimplePayment'

export default class SimplePaymentService extends WallexService {
    public static retrieve(simplePaymentId: string): Promise<SimplePaymentRetrieve> {
        return this.instance()
            .get('simple_payments/' + simplePaymentId)
            .then((response) => {
                const body = response.data as {
                    result: SimplePaymentRetrieve
                }

                return body.result
            })
    }

    public static update(simplePaymentId: string, payload: SimplePaymentRetrieve) {
        return this.instance()
            .patch('simple_payments/' + simplePaymentId, payload)
            .then((response) => {
                const body = response.data as {
                    result: SimplePaymentRetrieve
                }

                return body.result
            })
    }
}
